export default __webpack_public_path__ + "static/media/sso-icon.bcd68055.svg";